import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide006ParentVideoScripts() {
  return <KbGuidePage slug="guide-006-parent-video-scripts" />;
}

(Guide006ParentVideoScripts as unknown as { path: string }).path = "/guides/parent-video-scripts";
